import React, { useCallback, useMemo, useState } from 'react';

interface Value {
    standardClientOrgCode: string | null;
    confirmStandardClient: (orgCode: string) => void;
    clearStandardClient: () => void;
}

const context = React.createContext<Value | null>(null);

export const ClientFeatureFlagsBootstrapProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [standardClientOrgCode, setStandardClientOrgCode] = useState<string | null>(null);
    const confirmStandardClient = useCallback((orgCode: string) => {
        setStandardClientOrgCode(orgCode);
    }, []);
    const clearStandardClient = useCallback(() => {
        setStandardClientOrgCode(null);
    }, []);
    const value = useMemo(
        () => ({ standardClientOrgCode, confirmStandardClient, clearStandardClient }),
        [standardClientOrgCode, confirmStandardClient, clearStandardClient],
    );

    return <context.Provider value={value}>{children}</context.Provider>;
};

export const useClientFeatureFlagsBootstrap = () => {
    const value = React.useContext(context);
    if (!value) {
        throw new Error('ClientFeatureFlagsBootstrapProvider is not mounted.');
    }
    return value;
};
